import Vue from 'vue';
import axios from 'axios';
import storage from '../storage';
import { Message } from "element-ui";
axios.defaults.withCredentials = false;
//axios.defaults.headers["Referer"] = "http://ob.aivmcloud.com";

let request = {
	getLoginHeader(params2) {
		let admin_token=storage.get('token');
    if(typeof(admin_token)!='string')return params2;
    if(typeof(params2)!='object' || params2==null){
      params2={};
    }
    if(typeof(params2.headers)!='object' || params2.headers==null){
      params2.headers={};
    }
    params2.headers["Token"]=admin_token;
    return params2;
	},
	get(url, params) {
		params = this.getLoginHeader(params);
		return new Promise((resolve, reject) => {
			axios.get(url, params).then(function(res) {
				if(res.data.return_code == 10000200 || res.data.return_code == 10000000){
					console.log('res',res)
					Message.warning({
						message: '登录过期，请重新登录'
					});
					storage.remove('token');
					storage.remove('userInfo');
					top.window.location.href="/#/login";
				}
				else{
					resolve(res.data);
				}
				
			}, function(err) {
				reject(err)
			}).catch(function(err) {
				reject(err)
			});
		});
	},
	post(url, params, params2) {
		params2 = this.getLoginHeader(params2);
		return new Promise((resolve, reject) => {
			axios.post(url, params, params2).then(function(res) {
				if(res.data.return_code == 10000200 || res.data.return_code == 10000000){
					Message.warning({
						message:'登录过期，请重新登录' 
					});
					storage.remove('token');
					storage.remove('userInfo');
					top.window.location.href="/#/login";
				}
				else{
					resolve(res.data);
				}
			}, function(err) {
				reject(err)
			}).catch(function(err) {
				reject(err)
			});
		});

	},
	put(url, params, params2) {
		params2 = this.getLoginHeader(params2);
		return new Promise((resolve, reject) => {
			axios.put(url, params, params2).then(function(res) {
//				if(res.data.return_code == 10000200 || res.data.return_code == 10000000){
//					Message.warning({
//						message: '登录过期，请重新登录'
//					});
					
//					storage.remove('token');
//					storage.remove('userInfo');
//					top.window.location.href="/#/login";
//				}
//				else{
					resolve(res.data);
//				}
			}, function(err) {
				reject(err)
			}).catch(function(err) {
				reject(err)
			});
		});

	},
	delete(url, params, params2) {
		params = this.getLoginHeader(params);
		console.log('params',params)
		return new Promise((resolve, reject) => {
			axios.delete(url, params, params2).then(function(res) {
//				if(res.data.return_code == 10000200 || res.data.return_code == 10000000){
//					Message.warning({
//						message: '登录过期，请重新登录'
//					});
//					storage.remove('token');
//					storage.remove('userInfo');
//					top.window.location.href="/#/login";
//				}
//				else{
					resolve(res.data);
//				}
			}, function(err) {
				reject(err)
			}).catch(function(err) {
				reject(err)
			});
		});

	}
};

export default request;


// WEBPACK FOOTER //
// ./src/utils/request/index.js